<template>
    <div class="thecard">

        <div class="thefront" :class="{'thefrontClicked':cardClicked}" @click="showModal(index)">
        </div>

        <div class="theback">
            <h1 @click="showModal(index)">Confirm</h1>
        </div>
    </div>
</template>
<script>
   export default {
       props:{
           index: {
               type: Number,
               required: true
           }
       },
       data(){
           return{
               cardClicked:false
           }
       },
       methods:{
           showModal(index){
               this.cardClicked=true;
               this.$parent.showModal(index);
           }
       },
       computed:{

       }
   }
</script>
<style lang="sass" scoped >
    h1
        font-weight: bolder
        font-size: 5rem
        color: #2a3580
        text-align: center
    h2, h3, h4,h5,h6
        font-weight: 600
        text-align: center
        color: #2a3580
    .thecard
        position: relative
        top: 0
        left: 0
        width: 100%
        max-width: 160px
        height: 100%
        border-radius: 10px
        transform-style: preserve-3d
        transition: all 0.8s ease

        /*&:hover
            transform: rotateY(180deg)

        /* THE PSUEDO CLASS CONTROLS THE FLIP ON MOUSEOVER AND MOUSEOUT

        /* THE FRONT FACE OF THE CARD, WHICH SHOWS BY DEFAULT

        .thefront
            position: absolute
            top: 0
            background-size: cover
            background: url("../../public/mystery_card.png") no-repeat center
            left: 0
            display: grid
            justify-content: center
            width: 100%
            height: 100%
            border-radius: 10px
            backface-visibility: hidden
            overflow: hidden
            /*background: #3f5c6c
            /*border: 10px solid #2c3e50
            color: #000
        /*.thefrontClicked
         /*   background: #fbb03b!important
        /* THE BACK FACE OF THE CARD, WHICH SHOWS ON MOUSEOVER

        .theback
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            border-radius: 10px
            backface-visibility: hidden
            overflow: hidden
            background: #fafafa
            color: #333
            text-align: center
            border: 1px solid #ffc728
            transform: rotateY(180deg)

        /*This block (starts here) is merely styling for the flip card, and is NOT an essential part of the flip code

        .thefront svg
            margin: auto
            display: block
        .theback h1
            margin-top: 60%
            font-weight: bolder
            background-color: #ffc728
            font-size: 2.5rem
            color: #2a3580
            text-align: center

    $bgColor: #f4513d
    $color: #f2da5b

    @-webkit-keyframes rattle
        0%
            -webkit-transform: translateX(-2px)
            letter-spacing: -0.012em

        25%
            -webkit-transform: translateY(-2px) rotate(-1deg)
            font-size: 6.9999em

        50%
            -webkit-transform: translateX(1px)
            text-shadow: 0 1px 0 #000, 1px 1px 0 $bgColor, 2px 2px 0 $color, -3px -5px 0 $bgColor, -4px -6px 0 rgba($color, 0.6)

        75%
            -webkit-transform: translateY(1px)

        100%
            -webkit-transform: translateY(-2px)

    .multi-ani
        -webkit-animation: rattle 0.08s infinite alternate

</style>
